import React from 'react';
const FEATURED_IMG = 'https://cdn.magicpatterns.com/uploads/tAf6TYiASV1hZmDoDoayNF/Corporate-Planning-Protection-Training.png';
export function CapabilitiesSection() {
  return <section className="py-16 md:py-24 bg-brand-black" data-id="element-394">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-395">
        <h2 className="text-3xl md:text-4xl font-extrabold text-brand-white uppercase tracking-wide mb-4 text-center" data-id="element-396">
          Our Capabilities
        </h2>
        <p className="text-xl text-brand-gray-400 text-center mb-12" data-id="element-397">
          Corporate Security Strategies
        </p>

        <div className="w-full border border-brand-gray-800 overflow-hidden mb-16" style={{
        maxHeight: '320px'
      }} data-id="element-398">
          <img src={FEATURED_IMG} alt="Corporate Security Strategies" className="block w-full h-full object-cover object-center" onError={e => {
          e.currentTarget.src = 'https://cdn.magicpatterns.com/uploads/1k2RNSeLsdo1YWP3bfFU8J/Strategic-Preparedness.jpg';
        }} data-id="element-399" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-400">
          {/* Left Column */}
          <div data-id="element-401">
            <h3 className="text-lg font-bold text-brand-white uppercase tracking-wide mb-6 flex items-center gap-3" data-id="element-402">
              <div className="w-8 h-0.5 bg-brand-teal" data-id="element-403" />
              Corporate facility safety assessments for critical incidents such
              as:
            </h3>
            <ul className="space-y-4" data-id="element-404">
              {['Analysis of your business and a review and developmental updates of your current or future emergency response plans', 'Develop thorough and detailed response plans to protect your staff and your business', 'Educational and motivational lectures on workplace violence and other critical hazards in the office or in live webinar format', '24/7 response service to assist in providing updated review on current plans as well as after action assistance in the event of a critical incident regardless of the location. Whether in the United States or around the world, we are here for you every step of the way', 'Provide awareness training and education for your employees and the importance of knowing your duty to provide your employees with a workplace free from recognized hazards and to provide true reassurance of safety measures are always there for you'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-405">
                  <div className="w-1.5 h-1.5 bg-brand-teal flex-shrink-0 mt-2" data-id="element-406" />
                  <span className="text-brand-gray-300 leading-relaxed text-lg" data-id="element-407">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Right Column */}
          <div data-id="element-408">
            <h3 className="text-lg font-bold text-brand-white uppercase tracking-wide mb-6 flex items-center gap-3" data-id="element-409">
              <div className="w-8 h-0.5 bg-brand-teal" data-id="element-410" />
              We are always proud to work with the following clients:
            </h3>
            <ul className="space-y-4" data-id="element-411">
              {['Healthcare', 'Financial', 'Sports and Entertainment', 'Energy', 'Universities and all School Systems', 'Large Chain Product Distribution', 'All Airports around the world'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-412">
                  <div className="w-1.5 h-1.5 bg-brand-teal flex-shrink-0" data-id="element-413" />
                  <span className="text-brand-gray-300 leading-relaxed text-lg" data-id="element-414">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}